module.exports = __webpack_public_path__ + "static/media/1.b63e9b24.png";